@if (active) {
  <div class="w-100">
    <ng-content></ng-content>
  </div>
}
